import axios from 'axios';
import { useEffect, useState } from 'react';

const useApi = (request, url) => {
  const [data, setData] = useState(null);
  const [apiError, setApiError] = useState(false);

  useEffect(() => {
    axios[request](url)
      .then((response) => {
        setData(response.data.data);
      })
      .catch((e) => {
        setApiError(e);
        console.log(e.message);
      });
  }, [url, request]);

  return { apiError, data };
};

export default useApi;
